<template>
  <v-app class="bg-background">
    <v-app-bar app elevation="0" class="my-app-bg">
      <router-link to="/" custom v-slot="{ navigate }">
        <v-toolbar-title
          @click="navigate"
          style="cursor: pointer"
          class="text-h6"
        >
          Aisha
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>

      <!-- Hide tabs on mobile, show on desktop -->
      <v-tabs align-with-title class="d-none d-sm-flex">
        <v-tab to="/">Home</v-tab>
        <v-tab to="/about">About Me</v-tab>
        <v-tab to="/blog">Blog</v-tab>
        <v-tab to="/resources">Resources</v-tab>
        <v-tab to="/newsletter">Newsletter</v-tab>
        <v-tab href="mailto:hello.aishainsweden@gmail.com">Contact Me</v-tab>
      </v-tabs>

      <!-- Mobile menu button -->
      <v-app-bar-nav-icon
        class="d-sm-none"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Mobile navigation drawer -->
    <v-navigation-drawer v-model="drawer" temporary>
      <v-list>
        <v-list-item to="/" @click="drawer = false">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/about" @click="drawer = false">
          <v-list-item-title>About Me</v-list-item-title>
        </v-list-item>
        <v-list-item to="/blog" @click="drawer = false">
          <v-list-item-title>Blog</v-list-item-title>
        </v-list-item>
        <v-list-item to="/resources" @click="drawer = false">
          <v-list-item-title>Resources</v-list-item-title>
        </v-list-item>
        <v-list-item to="/newsletter" @click="drawer = false">
          <v-list-item-title>Newsletter</v-list-item-title>
        </v-list-item>
        <v-list-item
          href="mailto:hello.aishainsweden@gmail.com"
          @click="drawer = false"
        >
          <v-list-item-title>Contact Me</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="bg-background">
      <router-view></router-view>
    </v-main>

    <div class="custom-fixed-footer my-app-bg footer-with-border">
      <v-divider color="white" thickness="1"></v-divider>
      <AppFooter />
    </div>
  </v-app>
</template>

<script>
import AppFooter from "./components/AppFooter.vue";

export default {
  name: "App",
  components: {
    AppFooter,
  },
  data() {
    return {
      drawer: false,
    };
  },
};
</script>

<style>
.v-application {
  background-color: #0097a7 !important;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
}
.v-main {
  background-color: #0097a7 !important;
  padding-bottom: 120px !important;
}

@media (max-width: 599px) {
  .v-main {
    padding-bottom: 0 !important;
  }
}

.my-app-bg {
  background-color: #0097a7 !important;
  color: white !important;
}

/* Navigation drawer background and text color */
.v-navigation-drawer {
  background-color: #0097a7 !important;
}

.v-navigation-drawer .v-list-item-title {
  color: white !important;
}

.custom-fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

@media (max-width: 599px) {
  .custom-fixed-footer {
    position: static;
  }
}
.v-toolbar-title {
  display: flex;
  align-items: center;
}
</style>
